import React from "react";

const Home = () => {
    return (
        <h1>I am the Home page</h1>
    );
}

export default Home;